import {
  Box,
  Button,
  Card,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import {
  HeaderBreadcrumbs,
  ScreenError,
  ScreenWrap,
  SearchInput,
  SoloLoading,
} from '../../components';
import { Plus } from '@phosphor-icons/react';
import { Link } from 'react-router';
import useModifiableParams from '../../hooks/use-modifiable-params';
import { Api } from '../../api';

export default function UserClassificationsListScreen() {
  const { getParams, setModifiedParams, tablePaginationProps } =
    useModifiableParams();

  const params = getParams();
  const api = Api.ClientClassification.useReadCollection(params);

  return (
    <ScreenWrap>
      <Stack spacing={3} alignItems="stretch">
        <Stack spacing={1}>
          <HeaderBreadcrumbs
            title="User Classifications"
            items={[{ name: 'App Users', url: '/users' }]}
          />
          <Typography variant="body2" color="text.secondary">
            Clinicians can use these tags to label patients internally in the
            CMS - this won't be visible anywhere in the app.
          </Typography>
        </Stack>

        <Stack
          direction="row"
          alignItems="end"
          spacing={2}
          sx={{ width: '100%' }}
        >
          <SearchInput
            label="Search"
            value={params.name || ''}
            onChange={(e) =>
              setModifiedParams({ name: e.target.value, page: '1' })
            }
            placeholder="Search by user classification"
          />
          <Box>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Plus />}
              component={Link}
              to="/user-classifications/new"
            >
              Create
            </Button>
          </Box>
        </Stack>

        <Stack spacing={2}>
          <Card>
            {api.error ? (
              <ScreenError {...api} />
            ) : api.data?.member ? (
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>User Classification</TableCell>
                      <TableCell>Description</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {api.data.member.map((classification) => (
                      <TableRow
                        key={classification.id}
                        component={Link}
                        to={`/user-classifications/${classification.id}`}
                        sx={{
                          cursor: 'pointer',
                          textDecoration: 'none',
                          '&:hover': {
                            backgroundColor: 'action.hover',
                          },
                        }}
                      >
                        <TableCell>
                          <Typography variant="body2" fontWeight={500}>
                            {classification.name}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">
                            {classification.description}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableFooter
                    sx={{
                      borderTop: '1px solid rgba(224, 224, 224, 1)',
                    }}
                  >
                    <TableRow>
                      <TablePagination
                        {...tablePaginationProps({
                          totalItems: api.data?.totalItems ?? 0,
                          rowsPerPage: 10,
                        })}
                        count={api.data?.totalItems ?? 0}
                        colSpan={2}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            ) : (
              <SoloLoading />
            )}
          </Card>
        </Stack>
      </Stack>
    </ScreenWrap>
  );
}
